import { render, staticRenderFns } from "./InventoryBalance.vue?vue&type=template&id=267e3ae3"
import script from "./InventoryBalance.vue?vue&type=script&lang=js"
export * from "./InventoryBalance.vue?vue&type=script&lang=js"
import style0 from "./InventoryBalance.vue?vue&type=style&index=0&id=267e3ae3&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267e3ae3')) {
      api.createRecord('267e3ae3', component.options)
    } else {
      api.reload('267e3ae3', component.options)
    }
    module.hot.accept("./InventoryBalance.vue?vue&type=template&id=267e3ae3", function () {
      api.rerender('267e3ae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/InventoryBalance.vue"
export default component.exports